module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5d8cc0ff0d1ea048583ee33e9fd1a248.png";